import { TailwindThemeHelper, cssVariables } from '@nfctron/nexus-react';

const themeCssVariables = {
	...cssVariables,
} as const;

export type ThemeCssVariables = typeof themeCssVariables;

export const { getThemeColor, getFontSize, getFontWeight, getBorderRadius, getBoxShadow, getCssVariableValue } = new TailwindThemeHelper(
	themeCssVariables,
);
